import { PushPayload } from '../dto/PushEnvelope';

export function withVersionCheck({ onSnapshot, onMessage }: { onSnapshot: (any) => void; onMessage: (any) => void }) {
    let version: number | null = null;
    let matchVersions: { [key: string]: number } | null = null;

    const checkVersion = (payload: PushPayload) => version == null || payload.v == null || payload.v > version;
    const checkMatchVersion = (payload: PushPayload) =>
        matchVersions == null ||
        payload.v == null ||
        matchVersions[payload.vid || payload.d.id] == null ||
        payload.v > matchVersions[payload.vid || payload.d.id];

    return {
        onSnapshot: data => {
            version = data['version'];
            matchVersions = data['versions'];
            onSnapshot(data);
        },
        onMessage: (payload: PushPayload) => {
            if (!checkVersion(payload)) {
                console.log(`Discarded push message based on snapshot version`, { payload, version });
                return;
            }
            if (!checkMatchVersion(payload)) {
                console.log(`Discarded push message based on snapshot match version`, { payload, matchVersions });
                return;
            }
            onMessage(payload);
        }
    };
}
